import React from "react";
// Icons
import CheckCircleRounded from "@mui/icons-material/CheckCircle";
import CancelRounded from "@mui/icons-material/Cancel";

export default function PassValidation(props) {
  const { passValid, password } = props;
  return (
    password !== "" &&
    !passValid.passValid && (
      <>
        <div className="mt-10 d-flex gray-color">
          {passValid.charNumberValid ? (
            <CheckCircleRounded className="primary-color fs-20" />
          ) : (
            <CancelRounded className="error-color fs-20" />
          )}
          <span className="fs-15"> &nbsp; 6-20 characters</span>
        </div>
        <div className="mt-10 d-flex gray-color">
          {passValid.specialCharValid ? (
            <CheckCircleRounded className="primary-color fs-20" />
          ) : (
            <CancelRounded className="error-color fs-20" />
          )}

          <span className="fs-15">&nbsp; 1 special character</span>
        </div>
        <div className="mt-10 d-flex gray-color">
          {passValid.uppercaseValid ? (
            <CheckCircleRounded className="primary-color fs-20" />
          ) : (
            <CancelRounded className="error-color fs-20" />
          )}
          <span className="fs-15"> &nbsp; 1 uppercase letter</span>
        </div>
        <div className="mt-10 d-flex gray-color">
          {passValid.numberValid ? (
            <CheckCircleRounded className="primary-color fs-20" />
          ) : (
            <CancelRounded className="error-color fs-20" />
          )}

          <span className="fs-15"> &nbsp; 1 number</span>
        </div>
      </>
    )
  );
}
